import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Carousel.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/SearchBox.jsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
